export const SHIPPING_LABEL_CSS_PIXELS_PER_INCH = 96;
export const SHIPPING_LABEL_WIDTH_INCHES = 4;
export const SHIPPING_LABEL_HEIGHT_INCHES = 6;
export const SHIPPING_LABEL_CUSTOM_SECTION_MIN_HEIGHT_INCHES = 0.25;
export const SHIPPING_LABEL_CUSTOM_SECTION_MAX_HEIGHT_INCHES = 1;
export const SHIPPING_LABEL_CUSTOM_SECTION_DEFAULT_HEIGHT_INCHES = 0.25;
export const SHIPPING_LABEL_REDO_LOGO_HEIGHT_PX = 50;
export const SHIPPING_LABEL_REDO_LOGO_GAP_PX = 10;
export const SHIPPING_LABEL_REDO_LOGO_HEIGHT_INCHES = 1 / 6;
export const SHIPPING_LABEL_REDO_LOGO_WIDTH_INCHES =
  (SHIPPING_LABEL_REDO_LOGO_HEIGHT_INCHES * 75) / 24;
export const SHIPPING_LABEL_REDO_LOGO_TEXT_GAP_INCHES = 1 / 16;

export function getShippingLabelCarrierAreaHeightInches(
  customSectionHeightInches: number,
): number {
  return SHIPPING_LABEL_HEIGHT_INCHES - customSectionHeightInches;
}
